import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-experts-stats',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './experts-stats.html',
  styleUrl: './experts-stats.scss',
})
export class ExpertsStatsComponent {
  @Input() totalExperts: number = 12;
  @Input() averageRating: number = 4.8;
  @Input() totalReviews: number = 3504;
  @Input() certifiedExperts: number = 12;
}
